﻿import { IEditor } from "../interface/editor";
import { ValidatorError } from "../types/validator-error";
import { ValidatorFn } from "../types/validator-fn";
import { ValidatorParam } from "../interface/validator-param";
import { isValidatorDisabled } from "./is-validator-disabled";

export interface urlValidatorParam extends ValidatorParam {
    checkScheme?: boolean;
    validSchemes?: string;
}

export function urlValidator(param: urlValidatorParam): ValidatorFn {
    return (editor: IEditor): ValidatorError | null => {
        if (isValidatorDisabled(param, editor)) {
            return null;
        }

        if (editor.value !== undefined && editor.value != null && editor.value !== '') {
            let regStr = `(([0-9a-z_!~*'().&=+$%-]+:)?[0-9a-z_!~*'().&=+$%-]+@)?(([0-9]{1,3}\\.){3}[0-9]{1,3}|([0-9a-z_!~*'()-]+\\.)*([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\\.[a-z]{2,6})(:[0-9]{1,4})?((\\/?)|(\\/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+\\/?)`;
            if (param.validSchemes && param.validSchemes !== '') {
                regStr = '((' + param.validSchemes + '):\\/\\/)' +
                    (param.checkScheme ? '{1}' : '?')
                    + regStr;
            }

            let message='Validate Failed';
            if(param.message) {
                message= param.message;
            }

            const reg = new RegExp(regStr, 'i');
            if (!(reg.test(editor.value))) {
                return { message: message };
            } else {
                return null;
            }
        } else {
            return null;
        }
    };
}